jQuery ($) ->

# Donation amount
    $add_donation_amount = $('#add_donation_amount')
    if $add_donation_amount.length
        $add_donation_other_container = $('#add_donation_other_container')
        $add_donation_other = $('#add_donation_other')
        $add_donation_button = $('#add_donation')

        # Show "Other" field when needed
        update_donation_amount = (event) ->
            if $add_donation_amount.val() == 'other'
                $add_donation_other_container.show()
                if event
                    $add_donation_other[0].focus()
            else
                $add_donation_other_container.hide()

        update_donation_amount(false)
        $add_donation_amount.on('change', update_donation_amount)

        # Click the correct button when the user presses Enter (default is the
        # first button on the form, which is the Add/Remove Sponsorship button)
        $add_donation_other.on 'keydown', (event) ->
            if event.keyCode == 13
                $add_donation_button.click()
                return false
